const shareButton = document.querySelectorAll('[data-share')

if (navigator.share) {
	shareButton.forEach(element => {
		try {
			const data = JSON.parse(element.dataset.share)

			element.addEventListener('click', async () => {
				await navigator.share(data)
			})
		} catch (err) {
			console.error(err)
		}
	})
} else {
	import('clipboard').then(Clipboard => {
		new Clipboard('[data-clipboard-target]')
	})

	shareButton.forEach(element => {
		element.dataset.bsToggle = 'dropdown'

		element.addEventListener('show.bs.dropdown', event => {
			const input = event.target.querySelector('input')
			if (input) {
				input.focus()
				input.select()
			}
		})
	})
}
